module.exports = __webpack_public_path__ + "img/Play-rounded-button-outline.6fa2bbd2.svg";